/**
 * Returns true if the app is running in standalone/installed PWA mode.
 *
 * Reads `globalThis.matchMedia('(display-mode: standalone)')` (Chromium / Safari
 * macOS) and the iOS Safari fallback `(navigator as { standalone?: boolean }).standalone`.
 * Caller is responsible for SSR-guarding (`typeof window !== 'undefined'`) — this
 * helper assumes a browser context.
 */
export function isStandaloneDisplayMode(): boolean {
  return (
    globalThis.matchMedia('(display-mode: standalone)').matches ||
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
  );
}
